import store from '@/store';
import { createDateFormatter, getTimezoneAbbr } from '@goldcast/utils';

export const datesAreOnSameDay = (first, second) =>
  first.getFullYear() === second.getFullYear() &&
  first.getMonth() === second.getMonth() &&
  first.getDate() === second.getDate();

export function getTimeFormatterInEventLocale(locale = 'en-US') {
  return createDateFormatter(locale, {
    hour: 'numeric',
    minute: 'numeric'
  });
}

export function getDateFormatterInEventLocale(locale = 'en-US') {
  return createDateFormatter(locale, {
    month: 'short',
    day: 'numeric'
  });
}

export const timeFormatter = new Intl.DateTimeFormat('en', {
  hour: 'numeric',
  minute: 'numeric'
});

export const dateFormatter = new Intl.DateTimeFormat('en', {
  month: 'short',
  day: 'numeric'
});

export const getStartToEndDateInEventLocale = ({ startDate, endDate, locale = 'en-US' }) => {
  const makeDateFormatter = getDateFormatterInEventLocale(locale);
  const makeTimeFormatter = getTimeFormatterInEventLocale(locale);
  const startTimeString = makeTimeFormatter.format(startDate);
  const endTimeString = makeTimeFormatter.format(endDate);

  try {
    return datesAreOnSameDay(startDate, endDate)
      ? `${makeDateFormatter.format(startDate)} · ${startTimeString} - ${endTimeString} ${getTimezoneAbbr(startDate)}`
      : `${makeDateFormatter.formatRange(startDate, endDate)}`;
  } catch (e) {
    return '';
  }
};

export const startToEndDateString = (startDate, endDate) => {
  try {
    const startTimeString = timeFormatter.format(startDate);
    const endTimeString = timeFormatter.format(endDate);
    /* eslint-disable */
    return datesAreOnSameDay(startDate, endDate)
      ? `${dateFormatter.format(startDate)} · ${startTimeString} - ${endTimeString} ${getTimeZoneFromDate(startDate)}`
      : dateFormatter.formatRange(startDate, endDate);
    /* eslint-enable */
  } catch (e) {
    return '';
  }
};

export function isBefore(start, end) {
  return new Date(start).getTime() < new Date(end).getTime();
}

export function isAfter(start, end) {
  return new Date(start).getTime() > new Date(end).getTime();
}

export function isSameOrBefore(start, end) {
  return new Date(start).getTime() <= new Date(end).getTime();
}

export function isSameOrAfter(start, end) {
  return new Date(start).getTime() >= new Date(end).getTime();
}

export function timeDiff(start, end) {
  return new Date(end).getTime() - new Date(start).getTime();
}

export function getServerAdjustedDateTimeNow() {
  const serverAdjustedDateTime = new Date();
  const serverTimeDeltaInSeconds = Math.floor(store.state.session.serverTimeDelta / 1000);
  serverAdjustedDateTime.setSeconds(serverAdjustedDateTime.getSeconds() + serverTimeDeltaInSeconds);
  return serverAdjustedDateTime;
}

export function getTimeZone(date) {
  if (!date) {
    return '';
  }

  return new Date(date)
    .toLocaleDateString('en-Us', { day: '2-digit', timeZoneName: 'long' })
    .substring(4)
    .match(/\b(\w)/g)
    .join('');
}

export function getTimeZoneFromDate(date) {
  if (!date) {
    return '';
  }
  const jsDate = new Date(date);
  const formatter = Intl.DateTimeFormat({}, { timeZoneName: 'short' });
  const parts = formatter.formatToParts(jsDate);
  let timezone = '';

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (part.type === 'timeZoneName') {
      timezone = part.value;
      break;
    }
  }

  return timezone;
}
